// let media = window.matchMedia('(min-width: 992px)')
// if (media.matches) {
//   const comments = document.querySelectorAll('.wrote-about-us .comment-wrapper')
//   const heightArray = []
//   if (comments) {
//     Array.prototype.forEach.call(comments, (comment) => {
//       heightArray.push(comment.offsetHeight)
//     })
//   }
//   let getMax = Math.max.apply(Math, heightArray)
//   if (comments) {
//     Array.prototype.forEach.call(comments, (comment) => {
//       comment.style.minHeight = `${getMax-40}px`
//     })
//   }
// }
// window.addEventListener('resize', () => {
//   if (media.matches) {
//     const comments = document.querySelectorAll('.wrote-about-us .comment-wrapper')
//     const heightArray = []
//     if (comments) {
//       Array.prototype.forEach.call(comments, (comment) => {
//         heightArray.push(comment.offsetHeight)
//       })
//     }
//     let getMax = Math.max.apply(Math, heightArray)
//     if (comments) {
//       Array.prototype.forEach.call(comments, (comment) => {
//         comment.style.minHeight = `${getMax-40}px`
//       })
//     }
//   }
// })
